import facebookReducer from "./facebookreducer";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    facebookReducer,
})

export default rootReducer